import apiClient from './Request'
import { baseUrls, regionRoutingBaseUrl } from './../const'
import store from '@/store/store'

export default {
  getPatients(organisationId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/Board/GetPatient?organisationId=' +
        organisationId +
        '&flag=' +
        flag,
      data: data
    })
  },
  getPatientsWithLimit(perPage, page) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/patients?_limit=' + perPage + '&_page=' + page
    )
  },
  postPatients(patient) {
    return apiClient.post(baseUrls['baseUrl'] + '/patients', patient)
  },
  loginUser(user) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/api/user/login',
      data: user
    })
    //return apiClient.post('api/user/Login', user)
  },
  VerifyUserRegion() {
    return apiClient.get(regionRoutingBaseUrl + '/user/verifyuserregion')
  },
  UpdatePreferredRegion(region) {
    return apiClient.patch(
      regionRoutingBaseUrl + '/user/updatepreferredregion',
      { region }
    )
  },
  getPadFillProfile(patientId, fromDate, toDate) {
    let organisationId = store.getters[`user/selecteOrganisationId`]
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetPadFill?patientId=' +
        patientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&organisationId=' +
        organisationId
    )
  },
  getDashboardData() {
    return apiClient.get(baseUrls['baseUrl'] + '/Board/GetDashboardData')
  },
  getPatientDetail(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetPatientDetail?patientId=' + patientId
    )
  },
  getVoidingPattern(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetVoidingPattern?patientId=' +
        patientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate
    )
  },
  getVoidingPatternPeriod(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetVoidingPatternPeriod?patientId=' +
        patientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate
    )
  },
  GetDeviceStatus(fromDate) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetDeviceStatus?fromDate=' + fromDate
    )
  },
  GetPositionChart(patientId, fromDate, toDate) {
    let organisationId = store.getters[`user/selecteOrganisationId`]
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetPositionChart?patientId=' +
        patientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&organisationId=' +
        organisationId
    )
  },
  GetPatientGoal(patientId) {
    let organisationId = store.getters[`user/selecteOrganisationId`]
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/goal/GetPatientGoal?organisationId=' +
        organisationId +
        '&patientId=' +
        patientId
    )
  },
  SavePadFillProfileGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SavePadFillProfileGoal',
      data: data
    })
  },
  SaveSkinCareGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SaveSkinCareGoal',
      data: data
    })
  },
  SaveWetPadGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SaveWetPadGoal',
      data: data
    })
  },
  SavePositionGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SavePositionGoal',
      data: data
    })
  },
  SaveProductivityGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SaveProductivityGoal',
      data: data
    })
  },
  SaveTemperatureGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SaveTemperatureGoal',
      data: data
    })
  },
  SaveFallGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SaveFallGoal',
      data: data
    })
  },
  SendEmail(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/email/SendEmail', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  GetConsents() {
    return apiClient.get(baseUrls['baseUrl'] + '/data/GetConsents')
  },
  SavePatientConsent(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/data/SavePatientConsent',
      data: data
    })
  },
  SaveUserConsent(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/data/SaveUserConsent',
      data: data
    })
  },
  GetPatientConsent(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/data/GetPatientConsent?patientId=' + patientId
    )
  },
  GetUserConsent() {
    return apiClient.get(baseUrls['baseUrl'] + '/data/GetUserConsent')
  },
  DeletePatient(patientId) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/data/DeletePatient?patientId=' + patientId
    )
  },
  DeleteUser() {
    return apiClient.delete(baseUrls['baseUrl'] + '/user/deleteuser')
  },
  CheckConnection() {
    return apiClient.get(baseUrls['baseUrl'] + '/Board/CheckConnection')
  },
  GetGroups(filterName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/data/GetWGroups?filterName=' + filterName
    )
  },
  ChangeGroupStatus(groupId, isUrine) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/data/ChangeGroupStatus?groupId=' +
        groupId +
        '&isUrine=' +
        isUrine
    })
  },
  GetRoles(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/role/getroles?organisationId=' + organisationId
    )
  },
  GetUserRoles(filterName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/role/getuserroles?filterName=' + filterName
    )
  },
  UpdateUserRole(userId, organisationId, roleId) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/user/updateuserrole?userId=' +
        userId +
        '&organisationId=' +
        organisationId,
      data: roleId
    })
  },
  GetRolePermission(roleId, organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/role/getrolepermission?roleId=' +
        roleId +
        '&organisationId=' +
        organisationId
    )
  },
  SaveRolePermission(roleId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/role/saverolepermission?roleId=' + roleId,
      data: data
    })
  },
  ChangeGroupRetention(months) {
    return apiClient.put(
      baseUrls['baseUrl'] + '/data/ChangeGroupRetention?months=' + months
    )
  },
  ChangeSystemRetention(months) {
    return apiClient.put(
      baseUrls['baseUrl'] + '/data/ChangeSystemRetention?months=' + months
    )
  },
  DeleteRole(roleId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/role/DeleteRole?roleId=' + roleId
    )
  },
  ResetPassword(userId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/api/user/ResetPassword?userId=' + userId,
      data: data
    })
  },
  GetPatientBioPodRecord(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/BioRecord/GetPatientBioPodRecord?patientId=' +
        patientId
    )
  },
  GetBioPodRecord(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/BioRecord/GetBioPodRecord?patientId=' + patientId
    )
  },
  RefreshToken(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/api/user/RefreshTokenv2',
      data: data
    })
  },
  Logout(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/api/user/Logout',
      data: data
    })
  },
  silentFallByPatientId(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Board/SilentFallByPatientId',
      data: data
    })
  },
  getPatientProfile(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetPatientProfile?patientId=' + patientId
    )
  },
  getPatientPodDetail(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetPatientPodDetail?patientId=' + patientId
    )
  },
  getUserSite() {
    return apiClient.get(baseUrls['baseUrl'] + '/site/GetUserSite')
  },
  getSiteNodes(siteId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/site/GetSiteNodes?siteId=' + siteId
    )
  },
  getSiteMesh(siteId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/site/getsitemesh?siteid=' +
        siteId +
        '&flag=' +
        flag,
      data: data
    })
  },
  GetNetworkUtilisation(siteId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/site/GetNetworkUtilisation?siteid=' + siteId
    )
  },
  GetUserGroups(filterName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/report/GetUserGroups?filterName=' + filterName
    )
  },
  Download(fromDate, toDate, reportId, groups) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/report/Download?fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&reportId=' +
        reportId,
      data: groups,
      responseType: 'blob',
      timeout: 24 * 3600 * 1000
    })
  },
  generateNodeShareCode() {
    return apiClient.get(baseUrls['baseUrl'] + '/site/GenerateNodeShareCode')
  },
  saveGroupPasswordPolicy(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/group/SaveGroupPasswordPolicy',
      data: data
    })
  },
  resetGroupPasswordPolicy() {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/group/ResetGroupPasswordPolicy'
    })
  },
  getGroupPatientTree() {
    return apiClient.get(baseUrls['baseUrl'] + '/group/GetGroupPatientTree')
  },
  getUserPatients() {
    return apiClient.get(baseUrls['baseUrl'] + '/api/User/GetUserPatients')
  },
  GetManufactures() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/manufacture/GetManufactures'
    )
  },
  GetProductsByManufacturerId(manufacturerId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/product/GetProductsByManufacturerId?manufacturerId=' +
        manufacturerId
    )
  },
  GetPodStatusData() {
    return apiClient.get(baseUrls['baseUrl'] + '/Board/GetPodStatusData')
  },
  GetPodStatusDataSample() {
    return apiClient.get(baseUrls['signalRUrl'] + '/GetPodStatusDataSample')
  },
  AddToGroup(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['signalRUrl'] + '/AddToGroup',
      data: data
    })
  },
  GetAllPodsStatus(organisationId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/Board/GetAllPodsStatus?organisationId=' +
        organisationId +
        '&flag=' +
        flag,
      data: data
    })
  },
  GetPodStatus(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetPodStatus?patientId=' + patientId
    )
  },
  SaveSite(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/site/savesite',
      data: data
    })
  },
  SaveSiteNode(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/site/SaveSiteNode',
      data: data
    })
  },
  DeleteSiteNode(siteId, macAddress) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/site/DeleteSiteNode?siteId=' +
        siteId +
        '&macAddress=' +
        macAddress
    )
  },
  GetSitePods(siteId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/site/GetSitePods?siteId=' + siteId
    )
  },
  SaveSitePod(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/site/SaveSitePod',
      data: data
    })
  },
  DeleteSitePod(siteId, macAddress) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/site/DeleteSitePod?siteId=' +
        siteId +
        '&macAddress=' +
        macAddress
    )
  },
  GetAllThemes() {
    return apiClient.get(baseUrls['baseUrl'] + '/setting/getallthemes')
  },
  GetCustomThemes(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/setting/getallthemes?organisationId=' +
        organisationId
    )
  },
  SaveCustomTheme(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/setting/SaveCustomTheme',
      data: data
    })
  },
  DeleteCustomTheme(themeId, organisationId) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/setting/DeleteCustomTheme?themeId=' +
        themeId +
        '&organisationId=' +
        organisationId
    )
  },
  GetCustomTheme(name) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/setting/getcustomtheme?name=' + name
    )
  },
  // ApplyTheme(data) {
  //   return apiClient({
  //     method: 'post',
  //     url: baseUrls['baseUrl'] + '/setting/ApplyTheme',
  //     data: data
  //   })
  // },
  ApplyTheme(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/organisation/saveorganisationtheme ',
      data: data
    })
  },
  UploadIMGFile(type, data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/setting/UploadIMGFile?type=' + type,
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  GetAllPatients() {
    return apiClient.get(baseUrls['baseUrl'] + '/Membership/GetAllPatientsV2')
  },
  GetAllLocation() {
    return apiClient.get(baseUrls['baseUrl'] + '/setting/getalllocation')
  },
  GetMemberShipGroups() {
    return apiClient.get(baseUrls['baseUrl'] + '/Membership/getusergroups')
  },
  SavePatient(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Membership/SavePatient',
      data: data
    })
  },
  DeleteMemberShipPatient(patientId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/Membership/DeletePatient?patientId=' + patientId
    )
  },
  ArchivePatient(data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/Membership/ArchivePatient',
      data
    })
  },
  GetManufacturersByIds(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/Manufacture/GetManufacturersByIds',
      data: data
    })
  },
  GetManufacturerByCode(code) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/Manufacture/GetManufacturerByCode?code=' +
        code
    )
  },
  GetOrganisationManufacturer(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/GetOrganisationManufacturer?organisationId=' +
        organisationId
    )
  },
  AddOrganisationManufacturer(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Organisation/addorganisationmanufacturer',
      data: data
    })
  },
  UnArchivePatient(patientId) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/Membership/UnArchivePatient?patientId=' +
        patientId
    })
  },
  GetPatientNodes() {
    return apiClient.get(baseUrls['baseUrl'] + '/Membership/GetPatientNodes')
  },
  AssignNodeToPatient(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Membership/AssignNodeToPatient',
      data: data
    })
  },
  UnAssignNodeFromPatient(data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/Membership/UnAssignNodeFromPatient',
      data: data
    })
  },
  CreateGroup(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Membership/CreateGroupv2',
      data: data
    })
  },
  EditGroup(data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/Membership/EditGroup',
      data: data
    })
  },
  DeleteMemberShipGroup(groupId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/Membership/deletegroup?groupId=' + groupId
    )
  },
  CreateUser(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Membership/createuserv2',
      data: data
    })
  },
  CreateUserAccount(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/user/createUser',
      data: data
    })
  },
  UpdateUserAccount(userId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/user/updateUser?userId=' + userId,
      data: data
    })
  },
  DeleteUserAccount(userId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/user/deleteUser?userId=' + userId
    )
  },
  GetAllUserAccount(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/user/getallusers?organisationId=' + organisationId
    )
  },
  SaveOrganisationDateTimeSettings(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/group/saveOrganisationDateTimeSettings',
      data: data
    })
  },
  GetUserGroupsV2(filterName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/group/GetUserGroupsV2?filterName=' + filterName
    )
  },
  DownloadReport(organisationId, fromDate, toDate, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/Report/GetReport?organisationId=' +
        organisationId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&ReportType=1',
      data: data
    })
  },
  GetAllRegions() {
    return apiClient.get(baseUrls['baseUrl'] + '/setting/getAllRegions')
  },
  SaveOrganisation(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/Organisation/SaveOrganisation',
      data
    )
  },
  VerifyUser(domainName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/user/verifyuser?domainName=' + domainName
    )
  },
  SaveBuilding(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/Organisation/savebuilding',
      data
    )
  },
  GetBuildings(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/getbuildings?organisationId=' +
        organisationId
    )
  },
  DeleteBuilding(buildingIds) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/Organisation/deletebuilding',
      data: buildingIds
    })
  },
  GetAllPatientsV3(organisationId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/Membership/GetAllPatients?organisationId=' +
        organisationId +
        '&flag=' +
        flag,
      data: data
    })
  },
  DeleteOrganisationManufacturer(manufacturerId, organisationId) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/Organisation/deleteorganisationmanufacturer?manufacturerId=' +
        manufacturerId +
        '&organisationId=' +
        organisationId
    )
  },
  GetOrganisationDetail(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/getorganisationDetail?organisationId=' +
        organisationId
    )
  },
  GetOrganisationPatients(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/GetOrganisationPatients?organisationId=' +
        organisationId
    )
  },
  DeleteUserFromOrganisation(userId, organisationId) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/Organisation/deleteuserfromorganisation?userId=' +
        userId +
        '&organisationId=' +
        organisationId
    )
  },
  GetReportHistory(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/report/getreporthistory?organisationId=' +
        organisationId
    )
  },
  InviteUser(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/Organisation/Invite', data)
  },
  JoinOrganisation(code) {
    return apiClient.put(
      baseUrls['baseUrl'] + '/Organisation/join?code=' + code
    )
  },
  GetOrganisationProfile(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/GetOrganisationProfile?organisationId=' +
        organisationId
    )
  },
  VerifyInvitation(invitationToken) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/VerifyInvitation?invitationToken=' +
        invitationToken
    )
  },
  SaveAreaDetail(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/Organisation/saveareadetail',
      data
    )
  },
  GetBuildingAreas(buildingId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/getbuildingwards?buildingId=' +
        buildingId
    )
  },
  GetAreaByIds(wardIds) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/Organisation/getwarddetail',
      data: wardIds
    })
  },
  DeleteWard(wardId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/Organisation/deleteward?wardId=' + wardId
    )
  },
  GetUserFilter(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/user/getuserfilter?organisationId=' +
        organisationId
    )
  },
  SaveUserFilter(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/user/saveuserfilter', data)
  },
  GetAzureUserDetail() {
    return apiClient.get(baseUrls['baseUrl'] + '/user/GetAzureUserDetail')
  },
  GetPatientDataExport(organisationId, patientId) {
    return apiClient.put(
      baseUrls['baseUrl'] +
        '/report/getpatientdataexport?organisationId=' +
        organisationId +
        '&patientId=' +
        patientId
    )
  },
  GetPatientReportHistory(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/report/getpatientexporthistory?organisationId=' +
        organisationId
    )
  },
  GetPatientEventRecord(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/board/GetPatientEventRecord?fromDate=' +
        fromDate +
        '&patientId=' +
        patientId +
        '&toDate=' +
        toDate
    )
  },
  GetPatientActivity(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/board/GetPatientActivity?fromDate=' +
        fromDate +
        '&patientId=' +
        patientId +
        '&toDate=' +
        toDate
    )
  },
  GetPatientVoidRecord(patientId, fromDate, toDate) {
    let organisationId = store.getters[`user/selecteOrganisationId`]
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetPatientVoidRecord?fromDate=' +
        fromDate +
        '&patientId=' +
        patientId +
        '&toDate=' +
        toDate +
        '&organisationId=' +
        organisationId
    )
  },
  GetOrganisations(domainName) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/getorganisations?domainName=' +
        domainName
    )
  },
  GetIndividualPatientDetail(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Membership/getpatientdetail?patientId=' +
        patientId
    )
  },
  SaveFloor(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/Organisation/savefloor', data)
  },
  SaveRoom(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/Organisation/saveroom', data)
  },
  DeleteFloor(floorIds) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/Organisation/deletefloor',
      data: floorIds
    })
  },
  DeleteRoom(roomIds) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/Organisation/deleteroom',
      data: roomIds
    })
  },
  GetPatientHistory(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/goal/GetPatientHistory?patientId=' + patientId
    )
  },
  GetNonSmartzPad() {
    return apiClient.get(baseUrls['baseUrl'] + '/Membership/GetNonSmartzPad')
  },
  SubscribeEventEmailByEmail(email) {
    return apiClient.put(
      baseUrls['baseUrl'] + '/user/SubscribeEventEmailByEmail?email=' + email
    )
  },
  UnSubscribeEventEmailByEmail(email) {
    return apiClient.put(
      baseUrls['baseUrl'] + '/user/UnSubscribeEventEmailByEmail?email=' + email
    )
  },
  GetUserEmailSubscriptionByEmail(email) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/user/UserEmailSubscriptionByEmail?email=' + email
    )
  },
  CreateOrganisationReport(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/report/createorganisationreport',
      data
    )
  },
  GetOrganisationReportHistory(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/report/getorganisationreporthistory?organisationId=' +
        organisationId
    )
  },
  initializeMfa() {
    return apiClient.get(baseUrls['baseUrl'] + '/user/initializemfa')
  },
  verifyMfaCode(code) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/user/verifymfacode?code=' + code
    )
  },
  FetchUserDetails() {
    return apiClient.get(baseUrls['baseUrl'] + '/user/fetchuserdetails')
  },
  GetQRForPatient(patientId, ln) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/observation/getqrdetailsforpatient?patientId=' +
        patientId +
        '&ln=' +
        ln
    )
  },
  GetQRForOrganisation(organisationId, ln) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/observation/getqrdetailsforcommonarea?organisationId=' +
        organisationId +
        '&ln=' +
        ln
    )
  },
  GetPatientBladderChart(patientId, fromDate, toDate, ln, observationTypeId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetPatientBladderChart?fromDate=' +
        fromDate +
        '&patientId=' +
        patientId +
        '&toDate=' +
        toDate +
        '&ln=' +
        ln +
        '&observationTypeId=' +
        observationTypeId
    )
  },
  GetObservationValuesForLegend(ln, observationTypeId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/observation/GetObservationValuesForLegend?' +
        '&ln=' +
        ln +
        '&observationTypeId=' +
        observationTypeId
    )
  },
  CheckNodeNetwork(organisationId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/node/checknodenetwork?' +
        'organisationId=' +
        organisationId
    )
  },
  GetPatientsForObservationToPrint(organisationId) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/observation/GetPatientsForObservationToPrint?' +
        'organisationId=' +
        organisationId +
        '&flag=0',
      data: []
    })
  },
  ExportVoidingPadCycle(
    macFilter,
    startTime,
    endTime,
    inputUtcOffset,
    outputUtcOffset
  ) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        `/data/download?macFilter=${macFilter}&startTime=${startTime}&endTime=${endTime}&inputUtcOffset=${inputUtcOffset}&outputUtcOffset=${outputUtcOffset}`
    )
  },
  GetOrganisationShift(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/getorganisationshift?organisationId=' +
        organisationId
    )
  },
  SaveOrganisationShift(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Organisation/saveorgshift',
      data: data
    })
  },
  GetOrganisationBaselineTrial(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/getorganisationbaselinetrial?organisationId=' +
        organisationId
    )
  },
  SaveOrganisationBaselineTrial(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Organisation/saveorgbaselinetrialdate',
      data: data
    })
  },
  DeleteOrgShif(id) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/Organisation/DeleteOrgShift?id=' + id
    )
  },
  GenerateLinkKey(organisationId) {
    return apiClient.post(
      baseUrls['baseUrl'] +
        '/organisation/generatelinkkey?organisationId=' +
        organisationId
    )
  },
  GetLinkKey(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/getlinkkey?organisationId=' +
        organisationId
    )
  },
  RemoveLinkKey(organisationId) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/organisation/removelinkkey?organisationId=' +
        organisationId
    )
  },
  GetTemplateRoles() {
    return apiClient.get(baseUrls['baseUrl'] + '/role/gettemplateroles')
  },
  GetTemplateRolePermissions(roleName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/role/gettemplaterolepermission?role=' + roleName
    )
  },
  GetOrganisationSettingConfigs() {
    return apiClient.get(baseUrls['baseUrl'] + '/setting/getallsettings')
  },
  SaveOrganisationSettings(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/setting/saveuserorgsettings',
      data: data
    })
  },
  GetOrganisationSettings(organisationId) {
    return apiClient({
      method: 'get',
      url:
        baseUrls['baseUrl'] +
        '/setting/GetOrgSettings?organisationId=' +
        organisationId
    })
  },
  CheckBedNumber(roomId, bedNumber) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/Membership/CheckBedNumber?roomId=${roomId}&bedNumber=${bedNumber}`
    )
  },
  GetPatientsForObservation(organisationId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/observation/GetPatientsForObservation?organisationId=' +
        organisationId +
        '&flag=' +
        flag,
      data: data
    })
  },
  CreateSecondaryUser(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/user/createsecondaryuser',
      data
    )
  },
  ResetSecondaryUserPassword(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/user/resetsecondaryuserpassword',
      data
    )
  },
  GetInvitedUsers(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/organisation/GetInvitedUsers?organisationId=${organisationId}`
    )
  },
  LinkFacility(organisationId, uniqueCode) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/Installation/LinkFacility?organisationId=${organisationId}&uniqueCode=${uniqueCode}`
    )
  },
  UnLinkFacility(organisationId, siteId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/Installation/UnLinkFacility?organisationId=${organisationId}&siteId=${siteId}`
    )
  },
  GetLinkedSite(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/Installation/GetLinkedSite?organisationId=${organisationId}`
    )
  },
  LinkLoRaNetwork(organisationId, appId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/installation/linkloranetwork?appId=${appId}&organisationId=${organisationId}`
    )
  },
  UnLinkLoRaNetwork(organisationId, appId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/installation/unlinkloranetwork?appId=${appId}&organisationId=${organisationId}`
    )
  },
  GetLinkedLoRaNetwork(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/installation/getlinkednetwork?organisationId=${organisationId}`
    )
  },
  GetTeamScore(organisationId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/careplus/GetTeamScore?organisationId=' +
        organisationId +
        '&flag=' +
        flag,
      data: data
    })
  },
  GetOfflineNode(organisationId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        `/node/GetOfflineNode?organisationId=${organisationId}`
    )
  },
  GetDeviceFilter(organisationId, deviceToken) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/notification/getdevicefilter?organisationId=${organisationId}&deviceToken=${deviceToken}`
    )
  },
  GetFwVerV2(type) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + `/configurations/getfwverv2?type=${type}`
    )
  },
  GetOrganisationSetupCode(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/organisation/GetOrganisationSetupCode?organisationId=${organisationId}`
    )
  },
  GenerateOrganisationSetupCode(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/organisation/GenerateOrganisationSetupCode',
      data: data
    })
  },
  SavePodChangeHistory(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Membership/SavePodChangeHistory',
      data: data
    })
  },
  GetPodChangeHistory(podId, organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        `/Membership/GetPodChangeHistory?podId=${podId}&organisationId=${organisationId}`
    )
  },
  SavePadCycleFeedback(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Board/SavePadCycleFeedback',
      data: data
    })
  },
  SavePadWeight(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Board/SavePadWeight',
      data: data
    })
  }
}
